import { isElement } from '../domop/index';

import { Settings } from './config';

export const isAnchor = (node: Node) => isElement(node) && node.matches(Settings.selectorStructure);
export const isDocumentContent = (node: Node) => isElement(node) && node.matches(Settings.selectorDocumentContent);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/anchor/domUtils.tsx